import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";

import './PgCanal.css';

import { MeuContexto } from "../App"
import { validarME } from '../api/apiMe'
import { data_user } from '../api/datauser'
import CompActive from '../components/CompActive.jsx'
import VideoPlayer from '../components/VideoPlayer.jsx';

import { MdFavoriteBorder, MdShare } from "react-icons/md";
import {
    parseISO,
    formatDistance, isAfter,
} from 'date-fns';

import { ptBR } from 'date-fns/locale';

import personagem from '../img/person.png'

import { data_fatlives } from '../api/datafatlives'

import ModalCard from '../components/CompModal.jsx'
import ModalCardIugu from '../components/CompModalIugu.jsx'
import Iugu from './PgCard.jsx'
import IuguIngresso from './PgIngresso.jsx'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { FaInstagram, FaPlay, FaLock, FaGift, FaTicketAlt, FaShoppingCart, FaCreditCard, FaHeart } from 'react-icons/fa';
import { MdSubscriptions } from 'react-icons/md';

import { global } from '../api/global'
import Button from '../components/Button';

import CanalVideos from '../components/CanalVideos';

let vrcount = 0
let vruserid = ''

function PgCanal() {
    let { liveId } = useParams();
    let navigate = useNavigate();

    const [contarlive, setcontarlive] = useState(false)
    const [showVideoModal, setshowVideoModal] = useState(false);
    const [showmodalIugu, setshowmodalIugu] = useState(false);

    const [ativo, setativo] = useState(1)

    const { logado, setlogado, setusername, perfil, setperfil, novousuario, setnovousuario, user, setuser } = useContext(MeuContexto)

    const [isloading, setisloading] = useState(true);
    const [entrar, setentrar] = useState(false)
    const [pago, setpago] = useState(false)
    const [urlvideo, seturlvideo] = useState('')
    const [videoData, setVideoData] = useState({
        subtitles: [],
        qualities: [],
    });

    const [videoid, setvideoid] = useState('')
    useEffect(
        () => {
            _carregatela()
        }, [logado]
    )
    useEffect(
        () => {
            console.log(videoid, 'videoid')

            if (videoid != '') {
                seturlvideo(`${global.brl.REACT_APP_EVIPPLAY1ini}${videoid}/1/index.m3u8`)

                setshowVideoModal(true)
            }
        }, [videoid]
    )
    async function _carregatela() {
        const me = await validarME.me()
        if (me) {
            vruserid = me._id
            setcontarlive(false)
            setuser(me)
            setusername(me.username)
            setlogado(true)
        } else {
            setcontarlive(true)
            setlogado(false)
            setuser([])
        }
        Atualizar()
    }

    async function Atualizar() {

        //     console.log(liveId, 'liveId')

        const resposta = await data_user.telalink(liveId)

        //   console.log(resposta, 'resposta')

        if (resposta) {
            setperfil(resposta)

            const newSubtitles = [];
            if (resposta.legenda1) {
                newSubtitles.push({ id: 'pt-BR', lang: 'br', label: 'Português', src: resposta.legenda1, default: true });
            }
            if (resposta.legenda2) {
                newSubtitles.push({ id: 'en-US', lang: 'en', label: 'English', src: resposta.legenda2 });
            }
            if (resposta.legenda3) {
                newSubtitles.push({ id: 'es-ES', lang: 'es', label: 'Español', src: resposta.legenda3 });
            }

            // Mock qualities as they don't come from the API
            const mockQualities = [
                { id: '1080p', label: '1080p' },
                { id: '720p', label: '720p' },
                { id: '480p', label: '480p' },
            ];

            setVideoData({
                subtitles: newSubtitles,
                qualities: mockQualities,
            });

            if (resposta.online) {
                seturlvideo(`${global.brl.REACT_APP_EVIPLIVE1ini}${resposta._id}${global.brl.REACT_APP_EVIPLIVE1fim}`)

                if (resposta.paga) {
                    if (logado) {
                        const respostapgto = await data_fatlives.extratoPago(resposta._id, vruserid)
                        if (respostapgto.pago) {
                            setpago(true)
                        } else {
                            setpago(false)
                        }
                    } else {
                        setpago(false)
                    }
                } else {
                    // Video gratuito
                }
            } else {
                if (resposta.mostrar) {
                    if (resposta.linkultimo !== '') {
                        seturlvideo(`${global.brl.REACT_APP_EVIPPLAY1ini}${resposta._id}/${resposta.linkultimo}`)
                    }
                }
                if (resposta.linkplay !== '') {
                    seturlvideo(`${global.brl.REACT_APP_EVIPPLAY2ini}${resposta.linkplay}`)
                }

                if (resposta.paga) {
                    if (logado) {
                        const respostapgto = await data_fatlives.extratoPago(resposta._id, vruserid)
                        if (respostapgto.pago) {
                            setpago(true)
                        } else {
                            setpago(false)
                        }
                    } else {
                        setpago(false)
                    }
                } else {
                    // Video gratuito
                }
            }
        } else {
            setperfil([])
        }
        setisloading(false)
    }

    function copyToClipboard(e) {
        var textField = document.createElement('textarea')
        textField.innerText = `${import.meta.env.VITE_SITE_URL || 'https://smize.tv'}/Canal/${liveId}`
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()

        toast.info('Link Copiado para o compartilhamento!');
    };

    if (isloading) {
        return (
            <div className="min-h-screen bg-background flex items-center justify-center">
                <CompActive />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-background text-text">
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                theme="dark"
            />
            {showmodalIugu && (

                <ModalCardIugu isOpen={showmodalIugu} onClose={() => {


                    if (novousuario) { setlogado(true) }
                    setshowmodalIugu(false)
                }}  >

                    {(logado == true || perfil.paga == false) ? <>
                        <Iugu artista={perfil} publico={user} onClose={() => { setshowmodalIugu(false) }} />

                    </> :
                        <>
                            <IuguIngresso artista={perfil} publico={user} onClose={() => { setshowmodalIugu(false) }}></IuguIngresso>
                        </>
                    }

                </ModalCardIugu>


            )}
            {/* Video Player Modal */}
            {showVideoModal && (
                <div
                    className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center animate-fade-in"
                    onClick={() => setshowVideoModal(false)}
                >
                    <button
                        onClick={() => setshowVideoModal(false)}
                        className="absolute top-4 right-4 z-50 text-white hover:text-primary transition-colors"
                        aria-label="Fechar player de vídeo"
                    >
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>

                    <div
                        className="w-full max-w-6xl p-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <VideoPlayer
                            src={urlvideo}
                            subtitles={videoData.subtitles}
                            qualities={videoData.qualities}
                            fileName={perfil.username}
                        />
                    </div>
                </div>
            )}

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Channel Header */}
                <div className="bg-surface/50 backdrop-blur-sm rounded-2xl border border-border p-8 mb-8 shadow-lg">
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-6">

                        {/* Image */}
                        <div className="md:col-span-1 h-48 rounded-xl overflow-hidden">
                            <img
                                src={`${global.brl.REACT_APP_FOTO}${perfil.fotoid}.jpg`}
                                alt={`canal de ${perfil.title}`}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                        </div>



                        {/* Channel Info */}
                        <div className="flex-1 text-center md:text-left">
                            <h1 className="text-3xl font-bold font-display text-white mb-2">{perfil.username}</h1>
                            <p className="text-primary text-lg font-semibold mb-4">{perfil.estilo}</p>

                            {/* Stats and Actions */}
                            <div className="flex flex-wrap items-center justify-center md:justify-start gap-6 mb-6">
                                <div className="flex items-center gap-2">
                                    <MdFavoriteBorder className="text-red-400" size={24} />
                                    <span className="text-text-secondary">{perfil.seguidores}</span>
                                </div>

                                <button
                                    onClick={copyToClipboard}
                                    className="flex items-center gap-2 text-text-secondary hover:text-white transition-colors duration-200"
                                >
                                    <MdShare size={24} />
                                    <span>Compartilhar</span>
                                </button>

                                {perfil.instagram && (
                                    <a
                                        href={`https://www.instagram.com/${perfil.instagram}/`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-2 text-text-secondary hover:text-pink-400 transition-colors duration-200"
                                    >
                                        <FaInstagram size={24} />
                                        <span>@{perfil.instagram}</span>
                                    </a>
                                )}
                            </div>

                            {/* Next Live Info */}
                            <div className="bg-surface/30 rounded-xl p-4 mb-6 border border-border">
                                <h3 className="text-primary font-semibold mb-2">Próxima Live:</h3>
                                <p className="text-white font-medium mb-2">{perfil.title}</p>
                                {perfil.proximalive && (
                                    isAfter(parseISO(perfil.proximalive), new Date()) && (
                                        <p className="text-text-secondary text-sm">
                                            Em {formatDistance(parseISO(perfil.proximalive), new Date(), {
                                                locale: ptBR,
                                                addSuffix: false,
                                                includeSeconds: false
                                            }).replace("cerca de ", "")}
                                        </p>
                                    )
                                )}
                            </div>

                            {/* Action Buttons */}
                            <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                                {perfil.paga ? (
                                    pago ? (
                                        urlvideo && (
                                            <Button onClick={() => setshowVideoModal(true)} variant="watch" size="lg" className="w-full sm:w-auto">
                                                <FaPlay className="mr-2" />
                                                Assistir Agora
                                            </Button>
                                        )
                                    ) : (
                                        urlvideo && <div />
                                    )
                                ) : (
                                    <div />
                                )}

                                {perfil.paga && !pago && (<>


                                    {(perfil.preco != 0) ? (
                                        <Button onClick={() => setshowmodalIugu(true)} variant="ticket" size="lg" className="w-full sm:w-auto">
                                            <FaTicketAlt className="mr-2" />
                                            Ingresso
                                        </Button>
                                    ) : (<></>)
                                    }
                                    {(perfil.precoaluga != 0 && (perfil.precocompra != 0)) ? (<>
                                        <Button onClick={() => setshowmodalIugu(true)} variant="rent" size="lg" className="w-full sm:w-auto">
                                            <FaPlay className="mr-2" />
                                            Alugar
                                        </Button>

                                        <Button onClick={() => setshowmodalIugu(true)} variant="buy" size="lg" className="w-full sm:w-auto">
                                            <FaShoppingCart className="mr-2" />
                                            Comprar
                                        </Button></>
                                    ) : (<></>)
                                    }
                                    {(perfil.precoassinatura != 0) ? (
                                        <Button onClick={() => setshowmodalIugu(true)} variant="subscribe" size="lg" className="w-full sm:w-auto">
                                            <MdSubscriptions className="mr-2" />
                                            Assinar
                                        </Button>
                                    ) : (<></>)
                                    }
                                </>



                                )}

                                {!perfil.paga && urlvideo && (
                                    <>
                                        <Button onClick={() => setshowVideoModal(true)} variant="watch" size="lg" className="w-full sm:w-auto">
                                            <FaPlay className="mr-2" />
                                            Assistir Agora
                                        </Button>

                                        <Button onClick={() => setshowmodalIugu(true)} variant="contribute" size="lg" className="w-full sm:w-auto">
                                            <FaHeart className="mr-2" />
                                            Contribuir
                                        </Button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-12">
                    <CanalVideos artistaid={perfil._id} setvideoid={setvideoid} />
                </div>
                {/* About and Schedule Tabs */}
                <div className="mt-12">
                    <div className="border-b border-border">
                        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                            <button
                                onClick={() => setativo(1)}
                                className={`${ativo === 1 ? 'border-primary text-primary' : 'border-transparent text-text-secondary hover:text-white hover:border-gray-500'}
                                    whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
                            >
                                Sobre
                            </button>
                            <button
                                onClick={() => setativo(2)}
                                className={`${ativo === 2 ? 'border-primary text-primary' : 'border-transparent text-text-secondary hover:text-white hover:border-gray-500'}
                                    whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
                            >
                                Agenda
                            </button>
                        </nav>
                    </div>

                    <div className="mt-8">
                        {ativo === 1 && (
                            <div className="prose prose-invert max-w-none text-text-secondary">
                                <p>{perfil.descricao}</p>
                            </div>
                        )}
                        {ativo === 2 && (
                            <div className="prose prose-invert max-w-none text-text-secondary">
                                <p>Agenda de lives do canal.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
}

export default PgCanal;